// Dynamic icon loader - only imports icons that are actually used
// This prevents loading all 1000+ lucide icons

import {
  Award,
  Bike,
  Clock,
  Gift,
  MapPin,
  Mountain,
  Package,
  Settings,
  Shield,
  ShieldCheck,
  ShoppingBag,
  Snowflake,
  Sparkles,
  Store,
  Truck,
  Users,
  Wrench,
  Zap,
  type LucideIcon,
} from 'lucide-react'

// Map of icon names to actual icon components
export const iconMap: Record<string, LucideIcon> = {
  Award,
  Bike,
  Clock,
  Gift,
  MapPin,
  Mountain,
  Package,
  Settings,
  Shield,
  ShieldCheck,
  ShoppingBag,
  Snowflake,
  Sparkles,
  Store,
  Truck,
  Users,
  Wrench,
  Zap,
}

// Get icon by name with fallback
export function getIcon(name: string): LucideIcon {
  return iconMap[name] || Sparkles // Fallback to Sparkles if icon not found
}
